module.exports = __webpack_public_path__ + "static/favicon-aa139da76d50518f58a88d4080af134a.png";